import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Steps, Row, Col, message, Modal, Spin, Alert, DatePicker } from "antd";
import SurveyStepPeriode from "./SurveyStepPeriode";
import SurveyStepModeles from "./SurveyStepModeles";
import SurveyStepEmplacement from "./SurveyStepEmplacement";
import SurveyStepActionsKpi from "./SurveyStepActionsKpi";
import SurveyStepSecteur from "./SurveyStepSecteur";
import SurveyStepSimulation from "./SurveyStepSimulation";
import _ from "lodash";
import { withRouter } from "react-router-dom";

import { surveySetCurrentTitle } from "redux/actions/surveyActions";
import LocationType from "./SurveyStepActionsKpi/LocationType";
import {
  kpisApiUpsellProvider,
  actionsApiUpsellProvider,
  sectorsApiUpsellProvider,
  modelsApiUpsellProvider,
  surveyApiUpsellProvider,
  pdcsApiUpsellProvider
} from "../../../lib/api/providers";
import {
  setActionsList,
  setActionTypes,
  setKpisList,
  setModelsList,
  setSectorsList
} from "../../../redux/actions/surveyActions";
import moment from "moment-timezone";
import { setPDCS } from "../../../redux/actions/sectorsActions";

const Step = Steps.Step;

class CreateNewSurvey extends Component {
  componentDidMount() {
    //this.props.getSector(this.props.currentClient.id);
    //this.props.getKpiList();

    const location = this.props.location || {};
    const locationParams = location.params || {};
    this.loadData()
      .then(() => {
        if (locationParams.hasOwnProperty("duplicate") && location.state && location.state.survey) {
        } else {
          this.loadDraftFromStorage();
        }
      })
      .catch(e => {});
  }

  /**
   * Load initial data (model, kpis, sectors, actions)
   * @return {Promise<T | never>}
   */
  async loadData() {
    //load models, kpis, sectors
    this.setState({
      loading: true,
      indicators: true,
      message: "Chargement des données ..."
    });

    //load kpis
    return kpisApiUpsellProvider
      .post("/", {
        match: { client_id: [this.props.currentClient.id], id: { $gt: 0 } }
      })
      .then((response = {}) => {
        const kpis = response.data || [];
        this.props.setKpisList(kpis);
        //load actions
        return actionsApiUpsellProvider.post("/", {
          match: { client_id: [this.props.currentClient.id] },
          sort: { priority: 1, id: 1 }
        });
      })
      .then((response = {}) => {
        const actions = response.data || [];
        this.props.setActionsList(actions);
        this.props.setActionTypes(actions);
        //load sectors
        return sectorsApiUpsellProvider.post("/", {
          match: { client_id: this.props.currentClient.id },
          project: {
            _id: 1,
            sector_id: 1,
            sector_label: 1,
            pdcs: "$salepoints.pdc_id"
          }
        });
      })
      .then((response = {}) => {
        const sectors = response.data || [];
        this.props.setSectorsList(sectors);
        //load models
        return modelsApiUpsellProvider.post("/", {
          match: {
            active: [true, false],
            client_id: this.props.currentClient.id,
            //"periodicity.startDate": { $lt: { $date: moment().toDate() } },
            "periodicity.endDate": { $gt: { $date: moment().toDate() } }
          },
          sort: {
            retailer_label: 1,
            _id: -1,
            assortmentLabel: 1
          }
        });
      })
      .then((response = {}) => {
        const models = response.data || [];
        if (models.length === 0) {
          throw new Error("Aucun modèle disponible");
        }
        this.props.setModelsList(models);

        if (this.props.pdcs.length > 0) return true;

        return pdcsApiUpsellProvider
          .post(`/`, {
            project: {
              pdc_label: 1,
              pdc_id: 1,
              cp: "$adresse.cp",
              regionales: "$centrales.regionale.nom",
              retailer_id: "$retailer_id",
              _id: 0
            }
          })
          .then((response = {}) => {
            this.props.setPDCS(response.data || []);
          });
      })
      .then(() => {
        this.setState({
          loading: false,
          error: false,
          message: ""
        });
      })
      .catch(e => {
        const response = e.response || {};
        const msg = response.data || e.message || "";

        this.setState({
          loading: false,
          error: true,
          message: `Une erreur est survenue lors du chargement des données.(${msg})`
        });
      });
  }

  state = {
    current: 0,
    status: 0,
    disabled: true,
    displayDraftModal: false,
    loading: false,
    error: false,
    message: ""
  };

  /**
   * Load survey
   */
  loadSurvey() {
    const surveyData = this.props.location.state.survey || {};
    const progressData = {
      surveyProgress: {
        statusProgress: false,
        label: "",
        stepCreation: 0,
        periodicity: {},
        model: [],
        locations: [],
        sectors: [],
        locationTypes: [],
        surveyTitle: ""
      },
      simulationManager: {}
    };

    //set model
    try {
      const models = this.props.assortmentClient || [];
      const retailerId = surveyData.retailer.idRetailer;
      for (let i = 0; i < models.length; i++) {
        const model = models[i];
        if (model.retailer.idRetailer === retailerId) {
          const formattedModel = {};
          formattedModel._id = model._id;
          formattedModel.assortmentLabel = model.assortmentLabel;
          formattedModel.periodicity = model.periodicity;
          formattedModel.products = model.allProducts;
          formattedModel.ranges = model.allRanges;
          formattedModel.categories = model.allCategories;
          formattedModel.locationsStructure = model.locationsStructure;
          formattedModel.locations = model.allLocationTypes;
          formattedModel.client = model.client;
          formattedModel.retailer = model.retailer;
          formattedModel.idRetailer = model.retailer.idRetailer;
          formattedModel.retailerName = model.retailer.retailerName;

          progressData.surveyProgress.model = progressData.surveyProgress.model || [];
          progressData.surveyProgress.model.push(formattedModel);
        }
      }
    } catch (e) {
      console.log(e);
    }

    //set locations, locationsTypes
    try {
      const locationTypes = surveyData.metier.locationTypes || [];
      progressData.surveyProgress.locationTypes = locationTypes;

      for (let i = 0; i < locationTypes.length; i++) {
        const locationType = locationTypes[i];
        progressData.surveyProgress.locations.push({
          label: locationType.locationType,
          locationTypeId: locationType.locationTypeId,
          statements: []
        });
      }
    } catch (e) {}

    //set locations, locationsTypes
    try {
      for (let i = 0; i < surveyData.sectors.length; i++) {
        const sector = surveyData.sectors[i];
        progressData.surveyProgress.sectors.push({ label: sector.label });
      }
    } catch (e) {}
    this.props.loadSurveyProgress(JSON.stringify(progressData));
  }

  loadDraftFromStorage() {
    const draft = localStorage.getItem("upsell_survey_progress");
    if (draft) {
      this.setState({ displayDraftModal: true });
    }
  }

  next = () => {
    const current = this.state.current + 1;

    this.setState({ current });
  };

  nextStep = currentstep => {
    let current = currentstep + 1;
    this.setState({ current });
  };

  prev = () => {
    const current = this.state.current - 1;
    this.setState({ current });
  };

  prevStep = currentstep => {
    let current = currentstep - 1;
    this.setState({ current });
  };

  isStepCompleted(n = 0) {
    switch (n) {
      case 0:
        return this.props.surveyProgress.model &&
          this.props.surveyProgress.model[0] &&
          this.props.surveyProgress.model[0].retailerName
          ? this.props.surveyProgress.model[0].retailerName
          : null;
      case 1:
        return !_.isEmpty(this.props.surveyProgress.periodicity);
      case 2:
        return this.props.surveyProgress.locations && this.props.surveyProgress.locations.length > 0;
      case 3:
        const nbLocations = (this.props.surveyProgress.locations || []).length;
        const locations = this.props.surveyProgress.locationTypes || [];
        let nbLocationsCompleted = 0;
        for (let i = 0; i < locations.length; i++) {
          const location = locations[i];
          const locationType = new LocationType(location);
          nbLocationsCompleted += locationType.nbKpiSelected() > 0 ? 1 : 0;
        }
        return nbLocationsCompleted === nbLocations;
        return !(locations.length === 0 || nbLocationsCompleted < nbLocations);
      default:
        return false;
    }
  }

  continue = index => {
    let currentIndex = this.state.current;
    if (index === 0) {
      currentIndex = 0;
    }

    if (index === 1 && this.isStepCompleted(0) && this.isStepCompleted(1)) {
      currentIndex = 1;
    }

    if (index === 2 && this.isStepCompleted(0) && this.isStepCompleted(1) && this.isStepCompleted(2)) {
      currentIndex = 2;
    }

    if (index === 3 && this.isStepCompleted(0) && this.isStepCompleted(1) && this.isStepCompleted(2)) {
      currentIndex = 3;
    }

    if (
      index === 4 &&
      this.isStepCompleted(0) &&
      this.isStepCompleted(1) &&
      this.isStepCompleted(2) &&
      this.isStepCompleted(3)
    ) {
      currentIndex = 4;
    }
    this.setState({ current: currentIndex });
  };

  /**
   * Convert "2019-01-01" to {$date:"2019-01-01"}, data to {type:data}
   * Only if data != object
   * @param type
   * @param data
   * @returns {*}
   */
  buildTypedProperty(data) {
    return data;
  }

  // buildTypedProperty(type, data) {
  // 	if (typeof data === "object") {
  // 		return data;
  // 	} else {
  // 		return {
  // 			[type]: data,
  // 		};
  // 	}
  // }

  /**
   * get periodicyty status from startDate & endDate
   * @param previousStatus
   * @param startDateString
   * @param endDateString
   * @returns {*}
   */
  getPeriodicityStatus(previousStatus, startDateString, endDateString) {
    if (!startDateString || !endDateString) {
      return { id: 1, label: "Brouillon" };
    }

    if (previousStatus > 3) {
      return previousStatus;
    }

    const currentDate = new Date();
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    if (startDate < currentDate && currentDate < endDate) {
      return { id: 2, label: "Actif" };
    } else {
      return { id: 3, label: "Inactif" };
    }
  }

  /**
   * Generate surveyId
   * Format : nom du client + id model + période : soit GSKMMCARREFOUR151118301118
   * @returns {string}
   */
  generateAssortmentId() {
    const surveyProgress = this.props.surveyProgress || {};
    const surveyProgressModels = surveyProgress.model || [];
    const surveyProgressModel = surveyProgressModels[0] || {};

    //const surveyProgressModelPeriodicity = surveyProgressModel.periodicity || {};
    const surveyProgressModelPeriodicity = surveyProgress.periodicity || {};

    const sd = new Date(surveyProgressModelPeriodicity.startDate);
    const ed = new Date(surveyProgressModelPeriodicity.endDate);

    const surveyProgressModelAssortmentLabel = (surveyProgressModel.retailerName || "").toUpperCase();

    const sdDay = ("0" + sd.getDate()).slice(-2);
    const sdMonth = ("0" + (sd.getMonth() + 1)).slice(-2);
    const sdYear = ("" + sd.getFullYear()).slice(-2);

    const edDay = ("0" + ed.getDate()).slice(-2);
    const edMonth = ("0" + (ed.getMonth() + 1)).slice(-2);
    const edYear = ("" + ed.getFullYear()).slice(-2);

    return `${surveyProgressModelAssortmentLabel}${sdDay}${sdMonth}${sdYear}${edDay}${edMonth}${edYear}`;
  }

  /**
   * Generate surveyId
   * Format : nom du client + id model + période : soit GSKMMCARREFOUR151118301118
   * @returns {string}
   */
  generateSurveyId() {
    const surveyProgress = this.props.surveyProgress || {};
    const surveyProgressModels = surveyProgress.model || [];
    const surveyProgressModel = surveyProgressModels[0] || {};
    const surveyProgressModelClient = surveyProgressModel.client || {};
    const surveyProgressModelClientName = surveyProgressModelClient.companyName || "";

    return `${surveyProgressModelClientName}${this.generateAssortmentId()}`;
  }

  /**
   * Build final json from surveyProgress
   */
  buildFinalJSON() {
    const surveyProgress = this.props.surveyProgress || {};
    const surveyProgressModels = surveyProgress.model || [];
    const surveyProgressModel = surveyProgressModels[0] || {};

    const json = {};
    //json._id = surveyProgress._id || {};
    json.surveyId = this.generateSurveyId();
    json.assortmentId = this.generateAssortmentId();
    json.SurveyPeriodicity = surveyProgress.periodicity || {};
    json.SurveyPeriodicity.startDate = this.buildTypedProperty(json.SurveyPeriodicity.startDate);
    json.SurveyPeriodicity.endDate = this.buildTypedProperty(json.SurveyPeriodicity.endDate);
    json.status = this.getPeriodicityStatus(
      json.SurveyPeriodicity.status,
      json.SurveyPeriodicity.startDate,
      json.SurveyPeriodicity.endDate
    );
    delete json.SurveyPeriodicity.status;

    json.Assortmentperiodicity = surveyProgressModel.periodicity || {};
    json.Assortmentperiodicity.startDate = this.buildTypedProperty(json.Assortmentperiodicity.startDate);
    json.Assortmentperiodicity.endDate = this.buildTypedProperty(json.Assortmentperiodicity.endDate);

    json.kpiProducts = surveyProgress.kpiProducts || [];
    json.kpiSurvey = surveyProgress.kpiSurvey || [];
    json.sectors = surveyProgress.sectors || [];

    if (surveyProgress.usePdcs) {
      json.pdcs = surveyProgress.pdcs || [];
    }

    json.regionales = surveyProgress.regionales || [];
    json.surveylabel = surveyProgress.surveyTitle || "";
    //json.IMEI = surveyProgress.IMEI || "";
    //json.POSid = surveyProgress.POSid || "";
    //json.CSid = surveyProgress.CSid || "";
    json.metier = {};
    json.metier.ranges = surveyProgressModel.ranges || [];
    json.metier.products = surveyProgressModel.products || [];

    //add endVisitStatement
    if (surveyProgress.end_visit_statement) {
      json.metier.end_visit_statement = surveyProgress.end_visit_statement;
    }

    //filter statments with empty kpis
    const locationsTypes = surveyProgress.locationTypes || [];
    for (let i = 0; i < locationsTypes.length; i++) {
      const locationsType = locationsTypes[i] || {};
      locationsType.statements = locationsType.statements || [];
      locationsType.statements = _.orderBy(locationsType.statements, ["priority", "id"], ["asc", "asc"]);
      for (let j = locationsType.statements.length - 1; j >= 0; j--) {
        const statement = locationsType.statements[j];
        const kpis = statement.kpis || [];
        if (kpis.length === 0) {
          locationsType.statements.splice(j, 1);
        }
      }
    }

    json.metier.locationTypes = locationsTypes || [];
    json.startVisit = null;
    json.endVisit = null;

    json.models = [];
    //models
    for (let i = 0; i < surveyProgressModels.length; i++) {
      const aModel = surveyProgressModels[i];
      if (aModel._id) {
        json.models.push(aModel._id);
      }
    }

    //TODO remove .client
    json.client = surveyProgressModel.client || {};
    json.client._id = this.buildTypedProperty(json.client._id);

    json.client_id = surveyProgressModel.client_id;
    json.client_label = surveyProgressModel.client_label;

    json.retailer = surveyProgressModel.retailer || {};
    json.retailer._id = this.buildTypedProperty(json.retailer._id);
    json.surveyData = {};
    json.surveyAnswers = {};

    return json;
  }

  sendSurvey() {
    this.setState({
      loading: true,
      message: "Enregistrement du formulaire en cours..."
    });
    surveyApiUpsellProvider
      .post(`/createSurvey`, {
        elements: this.buildFinalJSON()
      })
      .then(() => {
        this.setState({
          loading: false,
          error: false
        });
        this.props.removeSurveyProgress();
        this.setState({ displayDraftModal: false });
        this.pushHistory();
        message.success("Votre formulaire à bien été enregistré");
      })
      .catch(e => {
        const response = e.response || {};
        const msg = response.data || "";
        this.setState({
          loading: false,
          error: true,
          message: `Une erreur est survenue lors de l'enregistrement du formulaire. (${msg})`
        });
      });
  }

  sucess = () => {
    return this.sendSurvey();
  };

  //processus à améliorer
  pushHistory = () => {
    this.props.history.push("/survey?refresh=1");
  };

  handleDisabled = status => {
    this.setState({ disabled: status });
  };

  onDraftModalOk() {
    const draft = localStorage.getItem("upsell_survey_progress");
    this.props.loadSurveyProgress(draft);

    try {
      const dataObj = JSON.parse(draft);
      if (dataObj.surveyProgress && dataObj.surveyProgress.model && dataObj.surveyProgress.model.length > 0) {
        //this.props.getLocation(321, dataObj.surveyProgress.model[0].idRetailer);
      }
    } catch (e) {}

    this.setState({ displayDraftModal: false });
  }

  onDraftModalCanceled() {
    this.props.removeSurveyProgress();
    this.setState({ displayDraftModal: false });
  }

  /**
   * Set status of step
   * @param currentIndex
   * @param item
   * @param index
   * @returns {*}
   */
  renderStep(currentIndex, item, index) {
    let status = "wait";

    if (currentIndex === index) {
      status = "process";
    }

    if (this.isStepCompleted(index) && index < currentIndex) {
      status = "finish";
    }

    let cursorStyle = "no-drop";

    if (index === 0) {
      cursorStyle = "pointer";
    }

    if (index === 1 && this.isStepCompleted(0) && this.isStepCompleted(1)) {
      cursorStyle = "pointer";
    }

    if (index === 2 && this.isStepCompleted(0) && this.isStepCompleted(1) && this.isStepCompleted(2)) {
      cursorStyle = "pointer";
    }

    if (index === 3 && this.isStepCompleted(0) && this.isStepCompleted(1) && this.isStepCompleted(2)) {
      cursorStyle = "pointer";
    }

    if (
      index === 4 &&
      this.isStepCompleted(0) &&
      this.isStepCompleted(1) &&
      this.isStepCompleted(2) &&
      this.isStepCompleted(3)
    ) {
      cursorStyle = "pointer";
    }

    return (
      <Step
        style={{ cursor: cursorStyle }}
        status={status}
        key={item.title}
        title={item.title}
        onClick={() => this.continue(index)}
      />
    );
  }

  render() {
    const {
      steps,
      surveyProgress,
      locations,
      currentSurvey,
      modelClient,
      locatonList,
      sectorList,
      surveySetCurrentTitle
    } = this.props;
    const { current, disabled } = this.state;

    if (this.state.loading) {
      return <Spin tip={this.state.message} />;
    }

    if (this.state.error) {
      return <Alert message={this.state.message} type="error" />;
    }

    let fullWidth = !this.state.indicators ? "p-content-page-center-full" : "";
    let indicatorBtn = !this.state.indicators ? "p-btn-blue" : "p-btn-blue";

    return (
      <Fragment>
        <Modal
          title="Reprise de la création d'un formulaire"
          visible={this.state.displayDraftModal}
          onOk={() => {
            this.onDraftModalOk();
          }}
          onCancel={() => {
            this.onDraftModalCanceled();
          }}
        >
          <p>Un formulaire est en cours de création, voulez-vous reprendre ?</p>
        </Modal>
        <div className={`p-content-page-center ${fullWidth}`}>
          <div className="p-content-page-center-header">
            <h2 className="p-content-page-center-header-title">Création d'un questionnaire</h2>
            <div className="p-content-page-center-header-buttons">
              <div className="p-content-page-center-header-buttons-item">
                <div
                  className={`p-content-page-center-header-buttons-item p-btn p-indicators ${indicatorBtn}`}
                  onClick={() => this.setState({ indicators: this.state.indicators ? false : true })}
                >
                  {this.state.indicators ? (
                    <span className="icon-arrow-right p-mrg-right-s" style={{ color: "#fff" }} />
                  ) : (
                    <span className="icon-arrow-left p-mrg-right-s" style={{ color: "#fff" }} />
                  )}
                  Étapes de création
                </div>
              </div>
            </div>
          </div>
          <div className="p-content-page-center-content p-mrg-top">
            <div className="p-txt-italic p-mrg-bot">- Titre du questionnaire :</div>
            <input
              placeholder="Choisissez un titre pour votre questionnaire"
              className="p-input-text p-survey-title p-w-100"
              id="surveyTitle"
              type="text"
              onChange={e => surveySetCurrentTitle(e.target.value)}
            />
            <div className="p-survey">
              {current === 0 && modelClient.length !== 0 && (
                <SurveyStepModeles
                  status={this.state.status}
                  steps={steps}
                  current={current}
                  prev={this.prevStep}
                  next={this.nextStep}
                  sucess={this.sucess}
                  surveyProgress={surveyProgress}
                  disabled={disabled}
                  handleDisabled={this.handleDisabled}
                  modeleList={modelClient}
                />
              )}
              {current === 1 && (
                <SurveyStepPeriode
                  status={this.state.status}
                  steps={steps}
                  current={current}
                  prev={this.prevStep}
                  next={this.nextStep}
                  sucess={this.sucess}
                  surveyProgress={surveyProgress}
                  disabled={disabled}
                  handleDisabled={this.handleDisabled}
                />
              )}

              {current === 2 && locatonList.length !== 0 && (
                <SurveyStepEmplacement
                  steps={steps}
                  current={current}
                  prev={this.prevStep}
                  next={this.nextStep}
                  sucess={this.sucess}
                  surveyProgress={surveyProgress}
                  locations={locations}
                  disabled={disabled}
                  handleDisabled={this.handleDisabled}
                />
              )}
              {current === 3 && (
                <SurveyStepActionsKpi
                  steps={steps}
                  current={current}
                  prev={this.prevStep}
                  next={this.next}
                  sucess={this.sucess}
                  disabled={disabled}
                  handleDisabled={this.handleDisabled}
                  prevAcess={this.prev}
                />
              )}
              {current === 4 && sectorList.length !== 0 && (
                <SurveyStepSecteur
                  steps={steps}
                  current={current}
                  prev={this.prevStep}
                  next={this.nextStep}
                  sucess={this.sucess}
                  disabled={disabled}
                  handleDisabled={this.handleDisabled}
                />
              )}
              {current === 5 && !_.isEmpty(currentSurvey) && (
                <SurveyStepSimulation
                  steps={steps}
                  current={current}
                  prev={this.prevStep}
                  next={this.nextStep}
                  sucess={this.sucess}
                  disabled={disabled}
                  currentSurvey={currentSurvey}
                />
              )}
            </div>
          </div>
        </div>
        {this.state.indicators ? (
          <div className="p-content-page-right">
            <h3 className="p-content-page-right-title">Étapes de création :</h3>
            <div className="p-content-page-right-banner">
              <Steps>{steps.map((item, index) => this.renderStep(current, item, index))}</Steps>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

CreateNewSurvey.defaultProps = {
  steps: [
    /*{
			title: "Titre",
		},*/
    {
      title: "Modèle"
    },
    {
      title: "Période"
    },
    {
      title: "Emplacement"
    },
    {
      title: "Actions & Kpis"
    },
    {
      title: "Cible"
    }
    /*{
			title: "Simulation",
		},*/
  ]
};

const mapStateToProps = (state, ownProps) => {
  return {
    surveyProgress: state.survey.surveyManager.surveyProgress,
    pdcs: state.sectors.pdcs || []
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    surveySetCurrentTitle: currentTitle => dispatch(surveySetCurrentTitle(currentTitle)),
    setKpisList: kpis => {
      dispatch(setKpisList(kpis));
    },
    setActionsList: actions => {
      dispatch(setActionsList(actions));
    },
    setActionTypes: statements => {
      dispatch(setActionTypes(statements));
    },
    setSectorsList: sectors => {
      dispatch(setSectorsList(sectors));
    },
    setModelsList: models => {
      dispatch(setModelsList(models));
    },
    setPDCS: pdcs => {
      dispatch(setPDCS(pdcs));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateNewSurvey));



// WEBPACK FOOTER //
// src/components/survey/create/index.js